module.exports = __webpack_public_path__ + "static/media/listing-page-shimla.62ab41ac.webp";